// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOZWDSqDB0fzXABMRs4n86Dv5teY5zW8U",
  authDomain: "chaitany-flowers-shop.firebaseapp.com",
  projectId: "chaitany-flowers-shop",
  storageBucket: "chaitany-flowers-shop.firebasestorage.app",
  messagingSenderId: "70766442201",
  appId: "1:70766442201:web:d84c6a4ccdc423daa2b0c8",
  measurementId: "G-L27ZVHSY6Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
